import {setThemeColors} from "@/helpers/whitelabel";
import iabDarkTheme from "@/data/defaults/dark.theme";
import iabLightTheme from "@/data/defaults/light.theme";
import {whitelabelService} from '@/services';
import i18n from '@/plugins/i18n';

let initialState = {
  lightTheme: iabLightTheme,
  darkTheme: iabDarkTheme
}

export default {
  state: () => initialState,
  mutations: {
    SET_LIGHT_THEME(state, {key, color}) {
      state.lightTheme[key] = color.hex
      setThemeColors(state.lightTheme)
    },
    SET_DARK_THEME(state, colors) {
      state.darkTheme = colors
      for (const key in state.darkTheme) {
        if (colors[key]) {
          state.darkTheme[key] = colors[key];
        }
      }
    },
    RESET_THEME(state) {
     state.lightTheme = iabLightTheme
     state.darkTheme = iabDarkTheme
    },
    SET_LIGHT_THEME_FROM_API(state, colors) {
      state.lightTheme = colors
      setThemeColors(state.lightTheme)
    }
  },
  actions: {
    async getThemeColors({commit, rootGetters}) {
      const subdomain = rootGetters['urls']?.subdomain
      try{
        if (subdomain){
          const response = await whitelabelService.getThemeColors(subdomain)
          if (response) {
            return commit('SET_LIGHT_THEME_FROM_API', response)
          }
        }
        return commit('SET_LIGHT_THEME_FROM_API', iabLightTheme)
      } catch (error) {
        console.error('Error fetching theme colors', error)
      }

    },
    async saveLightTheme({state, rootGetters, dispatch}) {
      const subdomain = rootGetters['urls'].subdomain
      if (!subdomain) return
      try{
        await whitelabelService.putThemeColors(JSON.stringify(JSON.stringify(state.lightTheme)))
        return dispatch('addNotification',
          {message: i18n.t('notification.save.success'), type: 'success'},
          {root: true})
      } catch (error) {
        console.error('Error saving theme colors', error)
      }
    },
    async resetTheme({commit}) {
      commit('RESET_THEME')
    }
  },
  getters: {
    lightTheme: state => {
      return state.lightTheme
    },
    darkTheme: state => {
      return state.darkTheme
    },
  }
}
